var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareChallenge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 104,
    viewBox: "0 0 122 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.808 86.6513C117.808 86.6513 118.982 89.2223 118.593 92.4221C118.593 92.4221 117.417 97.1245 110.275 99.5977C103.133 102.071 99.6008 99.5152 99.6008 99.5152C99.6008 99.5152 97.0556 97.2272 96.3495 94.0818L117.808 86.6513Z",
    fill: "url(#paint0_radial_2677_2561)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3678 94.151C97.6511 97.8569 103.311 98.7297 109.235 96.6783C115.16 94.6268 119.109 90.4265 117.826 86.7205C116.543 83.0146 110.697 81.6722 104.773 83.7236C98.8483 85.7751 95.0845 90.4451 96.3678 94.151Z",
    fill: "url(#paint1_radial_2677_2561)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.432 83.4901L99.2338 97.0302C99.2338 97.0302 97.1026 96.1893 96.3729 94.1492L111.053 82.7851C111.048 82.7869 113.616 83.111 114.432 83.4901Z",
    fill: "#FFC71F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.24 85.1233C100.953 86.6076 98.2344 89.987 99.1623 92.6667C99.2431 92.8999 99.3462 93.1138 99.4664 93.3102C100.794 95.4336 104.547 95.8463 108.466 94.4894C112.384 93.1325 115.099 90.48 114.834 87.9886C114.807 87.7599 114.754 87.5229 114.675 87.2948C113.753 84.6134 109.526 83.639 105.24 85.1233Z",
    fill: "url(#paint2_radial_2677_2561)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.877 86.9633C101.959 88.3201 99.2756 91.0487 99.4718 93.3084C100.799 95.4318 104.553 95.8444 108.471 94.4876C112.389 93.1307 115.105 90.4781 114.84 87.9868C113.597 86.0896 109.801 85.6046 105.877 86.9633Z",
    fill: "url(#paint3_radial_2677_2561)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.744 94.4611L115.02 92.7828L117.347 90.7523C117.349 90.7574 117.17 92.6538 113.744 94.4611Z",
    fill: "#EA5E22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.214 97.4748L103.602 98.3794L102.363 98.17L99.7776 97.2425L102.713 97.4565L106.214 97.4748Z",
    fill: "#EA5E22"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.278 87.3774L102.74 86.8713L104.496 85.4042L106.371 85.0216L108.781 84.4368L107.497 84.365L104.104 85.3133C104.104 85.3133 102.089 86.5683 101.278 87.3774Z",
    fill: "#EA5E22"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.696 99.0417L113.744 94.461C113.744 94.461 111.55 96.1205 108.24 97.0228L106.759 100.49C106.763 100.483 109.287 100.265 111.696 99.0417Z",
    fill: "#D9772F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1639 91.9694L99.0354 90.9751L99.3644 89.8802L96.41 90.9032L96.1639 91.9694Z",
    fill: "#FFC71F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.12127 11.7719C2.12127 11.7719 2.10258 14.3298 3.60627 16.8317C3.60627 16.8317 6.31602 20.2819 13.1322 19.6889C19.9484 19.0958 21.9243 15.6811 21.9243 15.6811C21.9243 15.6811 23.1821 12.8533 22.6029 9.98842L2.12127 11.7719Z",
    fill: "url(#paint4_radial_2677_2561)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6131 10.0496C22.9223 13.5882 18.5647 16.3989 12.9087 16.8892C7.25104 17.3842 2.43597 15.37 2.13153 11.833C1.82239 8.29442 6.1585 5.02961 11.8162 4.53463C17.4675 4.04271 22.304 6.51099 22.6131 10.0496Z",
    fill: "url(#paint5_radial_2677_2561)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.74585 7.91489L21.3122 13.488C21.3122 13.488 22.7663 12.0051 22.6131 10.0497L6.28292 6.08182C6.27823 6.08019 4.27437 7.29914 3.74585 7.91489Z",
    fill: "#FFC71F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9436 5.8663C16.0339 5.51175 19.531 7.29549 19.7494 9.85152C19.7673 10.0732 19.7616 10.2867 19.7356 10.4984C19.4253 12.7452 16.4733 14.4713 12.7335 14.8001C8.99529 15.1242 5.76459 13.9372 5.06726 11.7776C5.0052 11.5775 4.9574 11.3665 4.93956 11.1448C4.72109 8.5888 7.85328 6.22086 11.9436 5.8663Z",
    fill: "url(#paint6_radial_2677_2561)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0959 7.62697C15.8357 7.29819 19.0655 8.56373 19.734 10.5031C19.4237 12.7499 16.4717 14.4761 12.7319 14.8049C8.99366 15.1289 5.76296 13.9419 5.06564 11.7824C5.39542 9.75249 8.35301 7.94944 12.0959 7.62697Z",
    fill: "url(#paint7_radial_2677_2561)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.36739 16.7252L6.69134 15.8137L4.0201 14.9991C4.01703 14.9928 4.86803 16.4961 8.36739 16.7252Z",
    fill: "#EA5E22"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7029 16.4381L18.1961 16.219L19.141 15.5845L20.9356 13.8621L18.5904 15.1258L15.7029 16.4381Z",
    fill: "#EA5E22"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0504 6.269L14.6529 6.38941L12.6619 5.82608L10.9709 6.2022L8.75977 6.6084L9.79454 6.07861L12.9518 5.61115C12.9534 5.60646 15.0795 5.90125 16.0504 6.269Z",
    fill: "#EA5E22"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7477 19.756L8.3672 16.7251C8.3672 16.7251 10.7948 17.2872 13.8611 16.8093L16.3641 19.1264C16.3641 19.1264 14.1914 19.877 11.7477 19.756Z",
    fill: "#D9772F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9751 8.17354L19.2335 8.41183L18.5579 7.63136L21.3812 7.38458L21.9751 8.17354Z",
    fill: "#FFC71F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9941 97.5764C68.5499 95.3948 78.1205 92.0874 88.254 88.0762L90.7874 55.9865L56.0237 50.6383L57.9941 97.5764Z",
    fill: "url(#paint8_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M57.6415 66.5423L90.083 61.5459C90.083 61.5459 84.1014 71.7499 77.0642 74.2129C70.0974 76.7463 57.4304 68.1609 57.4304 68.1609L57.6415 66.5423Z",
    fill: "url(#paint9_linear_2677_2561)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3003 52.679C23.3003 52.679 30.619 90.6095 30.9708 90.9614C31.3931 91.3132 48.6342 96.0282 57.9937 97.5763L57.1492 50.4271L23.3003 52.679Z",
    fill: "url(#paint10_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2242 63.3052V63.3756L88.2538 88.0762C78.1202 92.0874 68.5496 95.4652 57.9939 97.5764C48.6344 96.0282 31.3932 91.3133 30.971 90.9614C30.7599 90.7503 27.8746 76.0426 25.6931 64.9238C25.6931 64.6423 25.6931 64.5015 25.6931 64.5015C25.6931 64.5015 30.7599 89.6243 31.9562 90.4688C33.1526 91.3133 56.6568 96.8727 57.3605 96.8727C57.4543 96.8727 57.642 96.8257 57.9235 96.7319C57.9704 96.7319 57.9939 96.7319 57.9939 96.7319C60.5976 96.1689 70.7312 93.1429 74.3905 92.1577C78.4721 91.1022 87.1278 88.428 87.4093 87.5132C87.6204 86.528 90.0835 61.5459 90.0835 61.5459C90.0835 61.5459 90.1538 62.1793 90.2242 63.3052Z",
    fill: "#4F6A00"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M25.2004 62.5311C25.2004 62.5311 33.2932 77.5204 41.949 78.2944C50.6047 79.1389 57.1493 66.8942 57.1493 66.8942L25.2004 62.5311Z",
    fill: "url(#paint11_linear_2677_2561)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6567 53.6642C56.6567 53.6642 93.4612 46.4159 92.6871 45.7826C91.913 45.1492 55.6715 40.3639 55.6715 40.3639C55.6715 40.3639 21.6114 46.6974 21.2596 47.2604C20.8373 47.8233 56.6567 53.6642 56.6567 53.6642Z",
    fill: "url(#paint12_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5935 50.1457C47.2269 50.2864 57.2197 51.9753 59.1901 51.6939C61.1605 51.4124 67.8458 50.0049 66.5792 49.2308C65.2421 48.5271 57.9938 47.3308 56.3048 47.4715C54.6159 47.5419 46.5935 50.1457 46.5935 50.1457Z",
    fill: "#FFFE84"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6374 64.0089L45.8194 66.8942L59.19 68.7239C62.3568 68.4424 62.6383 53.7346 59.5419 52.6791C56.4455 52.1161 29.9153 48.5271 21.2595 47.2604C20.8373 47.8234 21.8929 57.0421 24.6374 64.0089Z",
    fill: "url(#paint13_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M51.3787 53.7346C47.086 52.4679 28.6486 50.0752 25.6226 49.7234C22.5966 49.4419 24.7077 62.1792 28.3671 62.7422C31.956 63.3052 52.5046 66.683 53.9825 66.1904C55.3899 65.6978 55.7418 55.0013 51.3787 53.7346Z",
    fill: "url(#paint14_linear_2677_2561)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1899 68.7238L91.7018 61.4052C91.7018 61.4052 93.4611 46.4159 92.687 45.7826C92.2648 45.5011 59.5418 52.679 59.5418 52.679C60.1048 52.8198 59.8937 68.1609 59.1899 68.7238Z",
    fill: "url(#paint15_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M61.4416 53.5235C60.3156 54.2272 60.386 67.0349 61.7934 67.0349C63.1305 67.0349 90.5756 61.0533 90.646 60.0681C90.7867 59.1533 92.4053 46.9086 90.646 47.1901C88.8867 47.4012 62.5675 52.8198 61.4416 53.5235Z",
    fill: "url(#paint16_linear_2677_2561)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6,
    d: "M57.0792 47.4715C57.0792 47.4715 46.5234 49.7938 45.9604 50.7086C45.327 51.6939 48.7753 95.6763 48.7753 95.6763C48.7753 95.6763 37.6565 53.8754 40.8936 50.6383C44.1307 47.4012 56.4458 45.0789 56.4458 45.0789C56.4458 45.0789 75.3055 48.1049 75.3055 50.8494C75.3055 53.6643 71.1536 94.1985 71.1536 94.1985C71.1536 94.1985 70.4498 51.905 68.1979 50.8494C64.1164 48.9493 57.0792 47.4715 57.0792 47.4715Z",
    fill: "url(#paint17_linear_2677_2561)"
  }), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1534 94.7615L69.5349 94.6911L71.1534 94.1985C71.1534 94.1985 73.2646 51.4123 70.8016 50.3568C68.4089 49.3012 50.5344 45.29 50.5344 45.29L59.8939 42.8973C59.8939 42.8973 83.1166 46.5567 84.0315 47.2604C84.8759 47.9641 79.8092 91.5244 79.8092 91.5244L71.1534 94.7615Z",
    fill: "url(#paint18_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1534 94.7615L69.5349 94.6911L71.1534 94.1985C71.1534 94.1985 73.2646 51.4124 70.8016 50.3568C68.4089 49.3012 50.5344 45.29 50.5344 45.29L55.2493 45.0085C55.2493 45.0085 72.0683 49.5123 72.9127 50.2864C73.8275 50.9901 71.9275 94.48 71.9275 94.48L71.1534 94.7615Z",
    fill: "white"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8939 42.8973C58.6976 42.8973 32.5192 47.1197 30.9006 48.3864C29.2117 49.653 38.149 93.7763 38.149 93.7763L48.8455 96.38L50.5344 96.0985L48.7751 95.6763C48.7751 95.6763 42.8639 51.6938 44.7639 50.4975C46.664 49.2308 63.0606 44.5863 63.0606 44.5863L59.8939 42.8973Z",
    fill: "url(#paint19_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M42.1598 51.1308C42.3005 54.0161 42.7228 66.2608 37.656 65.9089C32.3077 65.6274 31.3929 51.1308 31.3225 48.9493C31.3225 48.8789 33.6448 49.5826 36.1782 50.0752C39.0634 50.5678 42.0894 50.9197 42.1598 51.1308Z",
    fill: "url(#paint20_linear_2677_2561)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M38.2191 45.6418C38.008 45.6418 32.7301 47.6826 36.2487 48.1049C39.7673 48.5975 48.7046 48.1752 48.7046 48.1752C48.7046 48.1752 56.3751 48.1049 61.7938 47.2604C67.142 46.4159 73.2644 45.0789 73.2644 45.0789C73.2644 45.0789 70.3088 42.827 65.9457 42.4047C61.653 41.9825 38.2191 45.6418 38.2191 45.6418Z",
    fill: "url(#paint21_linear_2677_2561)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M36.3895 47.1197C36.3895 47.1197 35.6858 47.5419 39.3451 47.8234C43.0748 48.1753 58.5567 47.1197 63.6235 46.4863C68.7606 45.7826 72.3496 45.0789 71.294 44.8678C70.2384 44.727 37.9377 46.6271 36.3895 47.1197Z",
    fill: "url(#paint22_linear_2677_2561)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8232 44.2344C58.5565 44.2344 45.0451 49.0197 43.4266 50.2864C41.7376 51.5531 47.297 95.5356 47.297 95.5356L48.8452 96.3801L50.5341 96.0986L48.7748 95.6763C48.7748 95.6763 42.8636 51.6939 44.7636 50.4975C46.6637 49.2308 63.0604 44.5863 63.0604 44.5863L59.8232 44.2344Z",
    fill: "white"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M57.29 68.7238L57.9937 97.5764C57.9937 97.5764 56.3048 86.3872 56.0233 81.3204C55.8122 76.2537 57.29 68.7238 57.29 68.7238Z",
    fill: "#F9FF53"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9302 24.6006C28.9302 24.6006 38.5712 15.6634 44.2713 18.6894C49.9011 21.7154 57.1494 44.9381 57.1494 44.9381L54.8271 45.5715C54.8271 45.5715 39.6971 27.697 33.6451 26.6414C29.2821 25.8673 27.7339 25.797 27.7339 25.797L28.9302 24.6006Z",
    fill: "url(#paint23_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M56.2347 44.6566C56.1643 44.6566 54.0531 41.9121 52.0124 37.549C49.8308 32.8341 47.7197 26.571 46.8752 26.7821C45.3974 27.2043 45.1863 32.6934 47.8604 35.9305C50.5345 39.1676 56.2347 44.6566 56.2347 44.6566Z",
    fill: "url(#paint24_linear_2677_2561)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M44.2715 34.312C49.6901 39.5195 54.8273 45.5715 54.8273 45.5715L57.1495 44.9381C57.1495 44.9381 56.3755 42.4751 55.1791 39.0973C50.8161 38.6047 47.4382 36.7046 44.2715 34.312Z",
    fill: "url(#paint25_linear_2677_2561)"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3754 46.6974C56.1643 46.6974 36.0379 47.753 33.5046 46.1344C30.9712 44.5863 23.0191 30.5822 27.5933 26.5007C32.2379 22.4895 36.6713 26.9933 38.501 29.0341C40.401 31.0748 56.3754 46.6974 56.3754 46.6974Z",
    fill: "url(#paint26_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M56.3757 46.6974C56.3053 46.6974 54.4052 46.7678 51.7311 46.9085C53.8423 45.0789 34.4196 30.8637 27.312 35.5786C26.0453 31.9193 25.6231 28.26 27.5935 26.5007C32.2381 22.4895 36.6715 26.9933 38.5012 29.0341C40.4012 31.0748 56.3757 46.6974 56.3757 46.6974Z",
    fill: "url(#paint27_linear_2677_2561)"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1932 46.1344C30.4783 45.6418 22.9485 27.3451 31.1116 25.5858C34.9821 24.7413 42.4415 32.9748 47.5083 38.4639C51.0269 42.2639 55.5307 46.7678 56.6567 46.4863L56.8678 46.2752L56.2344 44.6566C53.0677 45.5714 38.1489 22.5598 30.5487 24.2487C21.1188 26.3599 27.3819 46.5566 32.8709 47.19C38.36 47.8233 53.5603 47.4011 53.5603 47.4011L59.0493 46.5566L55.5307 46.2048C52.2232 46.2048 39.2748 46.627 35.1932 46.1344Z",
    fill: "url(#paint28_linear_2677_2561)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1495 42.4751C57.1495 42.264 51.9419 19.182 54.405 16.6486C56.7976 14.1152 69.3942 12.7781 73.2647 15.1708C77.0647 17.6338 71.6461 13.4115 69.3238 19.5338C67.0015 25.6562 62.2163 41.9121 62.2163 41.9121L59.331 44.164L57.1495 42.4751Z",
    fill: "url(#paint29_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M58.1347 45.9937C58.1347 45.9937 56.1642 34.7342 56.4457 32.3415C56.7272 29.8785 59.2606 21.4339 59.4014 23.7562C59.6125 26.0784 58.1347 45.9937 58.1347 45.9937Z",
    fill: "url(#paint30_linear_2677_2561)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M59.19 44.4455C58.1344 44.3752 59.4715 31.286 61.1604 28.9637C62.9197 26.5711 62.4974 35.0861 62.4974 34.4527C62.4974 33.8194 60.2455 44.4455 59.19 44.4455Z",
    fill: "url(#paint31_linear_2677_2561)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M53.7712 19.1115C53.4194 25.7969 57.1491 42.3343 57.1491 42.475L59.3306 44.164L62.2159 41.9121C62.2159 41.9121 62.5677 40.9269 62.9899 39.3083C55.6009 41.2083 54.6861 27.0636 53.7712 19.1115Z",
    fill: "url(#paint32_linear_2677_2561)"
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5978 44.8677C60.5978 44.8677 62.7793 38.8861 63.8349 34.5231C64.8201 30.2304 68.3387 13.3411 73.4758 15.6634C75.587 16.6486 78.4019 20.8005 79.2463 28.1192C79.8093 33.3267 79.0352 40.2936 78.05 41.4899C75.7277 44.164 62.2867 45.3603 61.3015 45.3603C60.3163 45.3603 60.5978 44.8677 60.5978 44.8677Z",
    fill: "url(#paint33_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M60.5978 44.8677C60.5978 44.8677 62.7793 38.8861 63.8349 34.5231C64.8201 30.2304 68.3387 13.3411 73.4758 15.6634C75.587 16.6486 78.4019 20.8005 79.2463 28.1192C78.2611 26.008 76.8537 23.545 75.7277 23.7561C73.9684 24.108 72.3499 28.7526 70.3795 31.9193C66.6498 37.8305 63.2719 45.1492 67.3535 44.727C64.3275 45.1492 61.7237 45.3603 61.3015 45.3603C60.3163 45.3603 60.5978 44.8677 60.5978 44.8677Z",
    fill: "url(#paint34_linear_2677_2561)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9975 15.0301C64.89 15.0301 62.7788 43.1085 59.8936 42.8974C59.8936 42.8974 60.4565 43.39 61.0195 43.953C61.0195 43.6011 61.0195 43.3196 61.0195 43.3196C65.8048 42.7566 66.3678 16.0153 72.3494 16.0153C79.1755 16.0153 80.6533 36.7047 76.9939 40.5751C73.405 44.3752 64.4677 44.1641 61.7936 44.5863C62.4269 45.2197 63.0603 45.7123 63.1307 45.7123C63.2714 45.7123 76.6421 44.5863 78.9644 41.9122C81.2163 39.1677 80.3014 15.0301 71.9975 15.0301Z",
    fill: "url(#paint35_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M73.4756 50.216C77.8386 49.3716 81.2869 48.4567 83.8906 47.5419C83.8906 47.5419 81.498 81.6723 79.8091 82.376C78.1201 83.0094 74.5312 73.861 74.5312 71.4684C74.5312 69.1461 73.4756 50.216 73.4756 50.216Z",
    fill: "url(#paint36_linear_2677_2561)"
  }), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3679 50.9197C47.7902 50.9901 59.4015 51.9753 59.5423 52.679C59.683 53.3124 60.1052 60.4903 59.8238 60.3496C59.6126 60.2792 58.9793 54.0865 58.2756 53.3828C57.6422 52.7494 47.3679 50.9197 47.3679 50.9197Z",
    fill: "#F9FF53"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3,
    d: "M34.7008 70.9054C34.2785 72.3832 38.5009 93.2837 38.9231 93.4244C39.4157 93.5652 46.101 95.6059 46.1714 95.2541C46.2418 94.9726 43.9195 72.2424 42.301 71.0461C40.7528 69.7794 35.123 69.4979 34.7008 70.9054Z",
    fill: "url(#paint37_linear_2677_2561)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M38.7117 93.2133C38.7117 93.2133 36.3895 83.9242 39.7673 84.2761C43.0748 84.5576 46.9453 95.4653 46.3823 95.3949C45.8193 95.3245 38.7117 93.2133 38.7117 93.2133Z",
    fill: "url(#paint38_linear_2677_2561)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2522 48.4567C31.6041 48.2456 43.4266 50.0049 43.1451 50.2864C42.8636 50.6383 40.8228 50.8494 39.7672 50.7086C38.6413 50.5679 29.9855 49.2308 31.2522 48.4567Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3497 49.3013C72.9831 49.0198 84.2426 46.979 84.0315 47.2605C83.75 47.542 74.109 50.3568 73.2645 50.1457C72.3497 49.9346 71.7164 49.5827 72.3497 49.3013Z",
    fill: "white"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8304 24.108C30.6897 24.108 35.475 23.8265 40.2603 28.26C43.1455 31.0748 46.8049 35.649 49.6197 38.9565C51.379 41.0676 53.2087 42.7566 53.2087 42.7566C53.2087 42.7566 50.8864 40.9973 48.8457 38.7454C45.5382 35.1564 41.5973 30.2304 38.7825 28.0488C34.2787 24.5302 31.9564 24.2487 30.8304 24.108Z",
    fill: "#FF5CA2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8601 37.9713C28.8601 37.9713 31.3935 45.29 34.2084 46.2048C37.0233 47.1197 51.4495 46.416 51.4495 46.416C51.4495 46.416 36.6714 46.6974 34.138 44.9381C31.5342 43.1788 28.8601 37.9713 28.8601 37.9713Z",
    fill: "#FF5CA2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7571 17.9153C54.9682 17.7042 57.2905 15.3115 62.0758 15.3819C66.9314 15.4523 68.8315 16.7893 68.8315 16.7893C68.8315 16.7893 63.3425 16.8597 61.0202 17.0708C58.6979 17.2116 54.7571 17.9153 54.7571 17.9153Z",
    fill: "#FF5CA2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7937 39.5195C61.7937 39.5195 63.7641 31.0749 64.8901 27.0637C66.016 23.0525 68.3383 17.2116 68.3383 17.2116C68.3383 17.2116 65.453 26.0785 64.3975 30.4415C63.3419 34.875 61.7937 39.5195 61.7937 39.5195Z",
    fill: "#FF5CA2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4451 24.6005C38.7118 24.0376 43.286 20.4486 42.723 19.956C42.0896 19.393 39.6266 21.2227 38.4303 22.2783C37.3043 23.2635 35.6858 25.3746 37.4451 24.6005Z",
    fill: "#FF5CA2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M41.527 42.5455C36.9528 41.7714 32.1675 42.9677 31.8157 43.39C31.3231 44.0937 32.6601 45.5715 35.9676 46.0641C39.2751 46.5567 49.9717 47.19 50.5346 45.7826C50.7457 45.3604 43.2159 42.827 41.527 42.5455Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M72.5609 94.1282C72.9127 94.1282 79.4573 91.8059 79.4573 91.454C79.4573 91.1022 80.3722 75.2685 76.9943 74.8462C73.6165 74.424 72.209 94.1282 72.5609 94.1282Z",
    fill: "url(#paint39_linear_2677_2561)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1132 72.3129C88.4651 72.3129 87.4095 85.9651 86.7058 86.8095C86.0725 87.7244 80.9353 89.2022 80.9353 89.2022C80.9353 89.2022 87.4095 72.3129 88.1132 72.3129Z",
    fill: "#FFFE84"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8236 28.4008C78.894 28.4711 80.1607 36.6343 77.6273 40.2936C75.0939 43.953 65.9456 44.3752 65.9456 44.3752C65.9456 44.3752 74.9532 43.5307 77.4162 38.3936C79.8792 33.3268 78.8236 28.4008 78.8236 28.4008Z",
    fill: "#FF5CA2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7529 46.8381C59.7529 46.8381 76.9941 50.4271 77.7681 47.5419C78.6126 44.5862 76.8533 37.4083 78.683 37.6898C80.5127 37.9713 85.6498 41.6306 85.6498 41.6306L88.4647 38.112C88.4647 38.112 77.557 30.7933 76.2903 33.9601C75.094 37.1268 77.557 46.5567 75.5866 46.8381C73.6866 47.0493 59.7529 46.8381 59.7529 46.8381Z",
    fill: "url(#paint40_radial_2677_2561)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9935 47.19C57.6417 47.19 43.4969 40.0824 38.782 40.7862C33.9967 41.4899 34.5597 52.3272 33.293 54.0865C32.0263 55.9161 26.9595 49.7234 26.6076 50.0753C26.2558 50.4271 28.7188 57.8866 28.7188 57.8866C28.7188 57.8866 36.3893 59.857 36.3893 56.3384C36.3893 52.8198 36.7412 44.2344 39.5561 43.3899C42.371 42.4751 57.9935 47.19 57.9935 47.19Z",
    fill: "url(#paint41_radial_2677_2561)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2907 40.4343C76.4315 43.038 76.5722 45.7122 76.4315 45.9233C76.2907 46.3455 77.4167 47.5418 77.6981 47.3307C77.9796 47.1196 77.7685 39.0268 77.487 38.6046C77.1352 38.1824 76.2203 37.3379 76.2907 40.4343Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8792 46.9085C61.0199 46.9085 68.6201 48.1048 69.4645 48.0345C70.3794 48.0345 72.0683 47.2604 71.5053 47.19C70.872 47.1196 60.8792 46.9085 60.8792 46.9085Z",
    fill: "#D42F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0195 41.2084C42.4418 41.2084 53.5605 45.3603 54.1235 45.5714C54.6161 45.7826 55.8124 46.2752 55.8124 46.2752C55.8124 46.2752 45.327 43.4603 43.9196 43.1788C42.5825 42.8269 42.0195 41.2084 42.0195 41.2084Z",
    fill: "#D42F55"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0051 34.0304C81.9903 34.3823 87.972 37.6194 87.6201 38.0416C87.1979 38.4639 85.72 41.138 85.72 41.138C85.72 41.138 81.5681 38.112 81.0755 37.7601C80.6533 37.4786 81.0051 34.0304 81.0051 34.0304Z",
    fill: "#FFF455"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1635 41.6306C36.8117 41.701 35.545 44.3752 35.1931 46.1345C34.9116 47.8938 36.6709 48.316 36.6709 47.753C36.6709 47.0493 38.2191 43.6011 38.2895 43.4603C38.5006 43.1788 37.1635 41.6306 37.1635 41.6306Z",
    fill: "#FFF455"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9593 50.4272C27.1 50.216 31.5335 54.1569 31.6038 54.5791C31.6038 54.931 29.9149 57.5347 29.7742 57.2532C29.563 56.9718 26.3963 51.1309 26.9593 50.4272Z",
    fill: "#FFF455"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5603 47.4012C53.9122 47.4012 63.8346 47.19 63.2013 45.29C62.6383 43.4603 59.8938 41.4899 57.29 41.701C54.7567 41.9121 53.9122 43.4603 54.1233 43.6714C55.6715 46.4863 53.4196 47.4012 53.5603 47.4012Z",
    fill: "url(#paint42_linear_2677_2561)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M53.5604 47.4012C53.9122 47.4012 63.8347 47.19 63.2013 45.29C62.6384 43.4603 59.8939 41.4899 57.2901 41.701C58.6272 41.8418 59.7531 42.3344 60.3865 42.827C63.6236 45.4307 60.4568 46.2048 57.5716 45.5715C56.0938 45.2196 54.6863 43.9529 54.1937 43.5307C55.953 46.5567 53.4196 47.4012 53.5604 47.4012Z",
    fill: "url(#paint43_linear_2677_2561)"
  }), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9529 42.6158C56.5159 42.4751 59.19 43.0381 58.9789 43.601C58.6974 44.164 55.9529 42.6158 55.9529 42.6158Z",
    fill: "#FF5CA2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2677_2561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.807 92.8067) rotate(160.9) scale(9.78346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D2246"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2677_2561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.477 84.4419) rotate(160.9) scale(16.9936 10.6278)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9748,
    stopColor: "#FF981F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2677_2561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.9343 91.3077) rotate(-109.1) scale(8.26031)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D2246"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2677_2561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.457 91.4563) rotate(-109.1) scale(7.87735 7.87735)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9748,
    stopColor: "#FF741F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2677_2561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.008 13.9046) rotate(-4.97903) scale(8.8573 8.8573)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D2246"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2677_2561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.36466 7.23829) rotate(-4.97902) scale(15.3843 9.6217)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9748,
    stopColor: "#FF981F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2677_2561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.6144 9.01923) rotate(-94.979) scale(7.47824 7.47824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D2246"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2677_2561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7578 10.4433) rotate(-94.979) scale(7.13152 7.13153)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9748,
    stopColor: "#FF741F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2677_2561",
    x1: 109.589,
    y1: 55.2631,
    x2: 105.635,
    y2: 93.3027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67762B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2677_2561",
    x1: 76.915,
    y1: 61.0512,
    x2: 76.3818,
    y2: 75.3888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2677_2561",
    x1: 79.7062,
    y1: 67.0835,
    x2: 73.7988,
    y2: 92.9627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5CE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2677_2561",
    x1: 45.2016,
    y1: 59.2602,
    x2: 45.0166,
    y2: 93.4624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2677_2561",
    x1: 54.751,
    y1: 55.9161,
    x2: 55.8822,
    y2: 37.8165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5CE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2677_2561",
    x1: 35.8441,
    y1: 70.4775,
    x2: 35.2392,
    y2: 54.1456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84A600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5CE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2677_2561",
    x1: 43.8355,
    y1: 45.0619,
    x2: 44.3194,
    y2: 60.5515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2677_2561",
    x1: 81.7146,
    y1: 40.39,
    x2: 94.1227,
    y2: 72.2966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67762B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2677_2561",
    x1: 81.7038,
    y1: 40.3717,
    x2: 84.279,
    y2: 63.7732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2677_2561",
    x1: 94.6592,
    y1: 34.9517,
    x2: 94.0723,
    y2: 143.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2677_2561",
    x1: 52.735,
    y1: 42.1465,
    x2: 87.8886,
    y2: 42.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#F03A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#F00C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E057D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2677_2561",
    x1: 2.71034,
    y1: 98.4483,
    x2: 1.11527,
    y2: 28.7448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA3A81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#F00C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E057D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2677_2561",
    x1: 24.6717,
    y1: 74.3916,
    x2: 19.1635,
    y2: 32.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E057D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2677_2561",
    x1: 53.7193,
    y1: 48.8818,
    x2: 53.518,
    y2: 40.0888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#812785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2677_2561",
    x1: 54.0557,
    y1: 47.9093,
    x2: 53.8952,
    y2: 54.7037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#812785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2677_2561",
    x1: 43.7632,
    y1: -17.5888,
    x2: 60.2868,
    y2: 33.4956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#F03A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#F00C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E057D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2677_2561",
    x1: 38.5664,
    y1: 48.3948,
    x2: 28.7393,
    y2: 35.6499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B62785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2677_2561",
    x1: 49.2721,
    y1: 51.3462,
    x2: 35.5146,
    y2: 28.6793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#812785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2677_2561",
    x1: 34.3504,
    y1: 54.8683,
    x2: 29.8331,
    y2: 24.8772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6006C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B004C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2677_2561",
    x1: 34.4513,
    y1: 54.6818,
    x2: 29.9584,
    y2: 24.8554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#812785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2677_2561",
    x1: 36.9314,
    y1: 52.3623,
    x2: 20.3868,
    y2: 23.3427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#F03A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#F00C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E057D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2677_2561",
    x1: 85.5087,
    y1: -3.60024,
    x2: 87.0005,
    y2: 38.9115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#F03A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#F00C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E057D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2677_2561",
    x1: 1.41541,
    y1: 81.2107,
    x2: -8.04297,
    y2: 68.9431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B62785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2677_2561",
    x1: 36.4795,
    y1: 57.3532,
    x2: 29.3834,
    y2: 48.1503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B62785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2677_2561",
    x1: 21.4804,
    y1: 43.411,
    x2: 25.5048,
    y2: 10.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#812785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2677_2561",
    x1: 43.4073,
    y1: 61.263,
    x2: 46.297,
    y2: 15.6253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6006C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B004C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2677_2561",
    x1: 60.5485,
    y1: 15.4642,
    x2: 79.228,
    y2: 15.4642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#812785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2677_2561",
    x1: 107.39,
    y1: 25.253,
    x2: 81.0814,
    y2: 63.5074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#F03A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#F00C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E057D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2677_2561",
    x1: 135.588,
    y1: 35.6955,
    x2: 138.967,
    y2: 71.1039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#912774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2677_2561",
    x1: 11.25,
    y1: 90.7214,
    x2: 4.94637,
    y2: 68.7007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2677_2561",
    x1: 49.3998,
    y1: 83.362,
    x2: 50.8646,
    y2: 98.1302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E057D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2677_2561",
    x1: 103.422,
    y1: 77.9517,
    x2: 102.039,
    y2: 99.5736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E057D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2677_2561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.1269 31.5625) rotate(145.917) scale(25.5658 25.5658)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_2677_2561",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0805 49.4708) rotate(0.510885) scale(23.5981 23.5981)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF80D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78A0C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2677_2561",
    x1: 59.05,
    y1: 23.417,
    x2: 60.8689,
    y2: 55.6994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F03A07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#F00C68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E057D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2677_2561",
    x1: 60.1507,
    y1: 43.347,
    x2: 60.3716,
    y2: 48.6496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#812785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareChallenge);
export default __webpack_public_path__ + "static/media/shareChallenge.f6aaf3ccacbc4e69db83284bc6d5483b.svg";
export { ForwardRef as ReactComponent };